module.exports = __webpack_public_path__ + "img/201612-4-1024x768.f2e65885.jpg";